import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "./index.css";
import { Layout } from "./routes/Layout";
import { DeviceList } from "./routes/DeviceList";
import { DeviceControl } from "./routes/DeviceControl";
import { Settings } from "./routes/Settings";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { seedServerBaseFromURL } from "./lib/settings";

// If the caller deep-linked with `?server=...`, persist it before any route
// renders so the initial fetch uses the right origin.
seedServerBaseFromURL();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<DeviceList />} />
            <Route path="device/:deviceId" element={<DeviceControl />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
